import { cls } from "../lib/cls";

interface LogoProps {
  className?: string;
  compact?: boolean;
}

export function Logo({ className, compact = false }: LogoProps): JSX.Element {
  if (compact) {
    return (
      <img
        src="/logo-compact.svg"
        alt="HyperGraphMind"
        className={cls("h-7 w-auto", className)}
      />
    );
  }
  return (
    <img
      src="/logo-lockup.svg"
      alt="HyperGraphMind"
      className={cls("h-7 sm:h-8 w-auto", className)}
    />
  );
}
